import React, { useState } from 'react';
import type { LscMember, LscMemberTeamOption } from '../types';

interface RestoreMemberModalProps {
  open: boolean;
  member: LscMember | null;
  teams?: LscMemberTeamOption[];
  teamsLoading?: boolean;
  restoring?: boolean;
  onClose: () => void;
  onConfirm: (teamLabel?: string) => void;
}

const RestoreMemberModal: React.FC<RestoreMemberModalProps> = ({
  open,
  member,
  teams = [],
  teamsLoading = false,
  restoring = false,
  onClose,
  onConfirm,
}) => {
  const [chosenTeam, setChosenTeam] = useState('');
  if (!open || !member) return null;

  const assignedTeam = (member.current_side_label || '').trim();
  const needsTeam = !assignedTeam;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      data-testid="restore-member-modal"
    >
      <div className="w-full max-w-md rounded-lg border border-secondary-700 bg-secondary-900 p-5 space-y-4">
        <div>
          <h2 className="text-lg font-semibold text-white">Restore member?</h2>
          <p className="mt-2 text-sm text-secondary-300">
            {assignedTeam
              ? `${member.display_name} returns to the roster on the ${assignedTeam}. The removal stays in history.`
              : `${member.display_name} needs a team before returning to the roster. The removal stays in history.`}
          </p>
        </div>
        {needsTeam ? (
          <label className="block text-sm text-secondary-200">
            Team
            <select
              className="mt-1 w-full rounded-md border border-secondary-600 bg-secondary-900 px-3 py-2 text-white"
              value={chosenTeam}
              disabled={teamsLoading || restoring}
              onChange={(event) => setChosenTeam(event.target.value)}
              data-testid="restore-member-team-select"
            >
              <option value="">{teamsLoading ? 'Loading teams...' : 'Choose a team'}</option>
              {teams.map((team) => (
                <option key={team.label} value={team.label} disabled={Boolean(team.is_claimed)}>
                  {team.label}
                </option>
              ))}
            </select>
          </label>
        ) : null}
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-secondary" disabled={restoring} onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled={restoring || (needsTeam && !chosenTeam)}
            onClick={() => onConfirm(needsTeam ? chosenTeam : undefined)}
            data-testid="restore-member-confirm"
          >
            {restoring ? 'Restoring...' : 'Restore'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestoreMemberModal;
